<script lang="ts">
export default {
  name: 'WebsiteLinkPreviewModal',
}
</script>
<script setup lang="ts" >
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { KkModal, KkIcon, KkButton } from '../../../../../../components/base'
import { camelCase } from '../../../../../../modules/string_converter'
const store = useStore()
const { t } = useI18n()

type SiteKey = 'google' | 'tabelog' | 'gnavi' | 'hot_pepper_gourmet' | 'retty' | 'trip_advisor' | 'yahoo_map'

interface WebsiteLinkItem {
  web_site_url: string
}
interface Props {
  isVisible: boolean
  title: string
  items: Record<SiteKey, WebsiteLinkItem>
}
interface Emits {
  (e: 'close'): void
}

const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
  title: '',
  items: (props: Props): Record<SiteKey, WebsiteLinkItem> => {
    return {
      google: { web_site_url: '' },
      tabelog: { web_site_url: '' },
      gnavi: { web_site_url: '' },
      hot_pepper_gourmet: { web_site_url: '' },
      retty: { web_site_url: '' },
      trip_advisor: { web_site_url: '' },
      yahoo_map: { web_site_url: '' }
    }
  }
})
const emit = defineEmits<Emits>()

const gmbLocationSynced = computed(() => store.getters['companiesStoreGmb/gmbLocationSynced'])
const companiesLocationStore = computed(() => store.getters['companiesLocationStore/store'])

// プレビューに表示させるのは連携しているサイトのみ
const displayedSiteTypes = computed(() => {
  const siteTypes = companiesLocationStore.value.attributes.site_types
  return Object.entries(siteTypes)
    .filter(([key, value]) => value !== null && Object.prototype.hasOwnProperty.call(value, 'web_site_url'))
    .map(([key, value]) => key as SiteKey)
})

const showProtectIcon = (site: SiteKey) => {
  return site === 'google' &&
         gmbLocationSynced.value.website_url_synced
}
</script>

<template>
  <KkModal :is-visible="props.isVisible" width="1076px" @change="emit('close')">
    <div class="p-modal__content__header">
      {{ props.title }}
    </div>
    <div class="p-modal__content__body">
      <div class="p-table">
        <div class="p-table__content">
          <table class="websiteLink">
            <thead>
              <tr>
                <th class="websiteLink__siteSection">{{ t('pages.CompaniesLocationStore.websiteLink.header.site') }}</th>
                <th>{{ t('pages.CompaniesLocationStore.websiteLink.header.url') }}</th>
              </tr>
              <tr class="p-table__content__space">
                <td colspan="4" />
              </tr>
            </thead>
            <tbody>
              <template v-for="site in displayedSiteTypes" :key="site">
                <tr>
                  <td class="websiteLink__site" :rowSpan="1">
                    <span class="websiteLink__section">
                      {{ t(`labels.sites.${camelCase(site)}`) }}
                      <KkIcon v-if="showProtectIcon(site)" class="websiteLink__icon" name="protection" color="#79acb0" />
                    </span>
                  </td>
                  <td class="websiteLink__detailText">
                    {{ props.items[site]?.web_site_url || '-' }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="p-modal__content__footer">
      <div class="c-button c-button--right">
        <KkButton
          class="footerCancelBtn"
          color="secondary"
          outlined
          :text="t('labels.close')"
          @click="emit('close')"
        />
      </div>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
@import '../../../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.websiteLink {
  height: 100%;
  &__siteSection {
    width: 25%;
  }
  &__section {
    display: flex;
    align-items: center;
    background-color: #f8f9fa;
    height: 100%;
  }
  &__site {
    background-color: #f8f9fa;
  }
  &__icon {
    width: 12px;
    margin-left: 5px;
  }
  td:empty {
    display: table-cell;
  }
  &__detailText {
    white-space: pre-wrap;
  }
}

.footerCancelBtn {
  margin-right: 8px;
}
</style>
